/**
 * Function to normalise the values (MIN / MAX could be integrated)
 * @param min Minimum expected value
 * @param max Maximum expected value
 */
export const normaliseByMinMax = (value: number, min: number, max: number) =>
  Number((((value - min) * 100) / (max - min)).toFixed(0));

/**
 * @param value
 * @param max Maximum expected value
 */
export const normaliseByMax = (value: number, max: number) =>
  Number(((value * 100) / max).toFixed(0));
